const appWriteConfig = {
  endpoint: "https://cloud.appwrite.io/v1",
  project_id: "67124fbc000336edcc41",
  database_id: "67125cfb0017bb8e48f8",
  users_collection_id: "67125d15002828536063",
  astros_collection_id: "67126032003829b9d3f8",
  // this storage id is for oceanic atlantic nft
  str_id: "676dde7d00357eff8d10",
  // str_id: "6715c319001613301065",
};

export default appWriteConfig;
